
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"Camada 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 64.06 63.93"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M63.6 26.64c-2.28-1.68-6.72-4.71-9.55-4.91s-4.58 1-5.31 2.82l-6.06-.74 6.52-6.52c1.82 1.08 4 1 6.19-1.21 2-2 3.3-7.27 3.91-10a1.18 1.18 0 00-1.42-1.41c-2.76.6-8 2-10 4-2.15 2.23-2.28 4.38-1.21 6.19l-6.52 6.47-.74-6c1.81-.74 3-2.43 2.82-5.32S39 2.68 37.32.46a1.23 1.23 0 00-2 .13c-1.41 2.49-3.83 7.27-3.63 10.1.2 3.29 1.95 4.77 4.17 5L37 24.44l-7.4 7.4-.74-6.06c1.82-.74 3-2.42 2.83-5.31s-3.23-7.33-4.91-9.56a1.23 1.23 0 00-2 .14c-1.42 2.49-3.84 7.27-3.64 10.09.21 3.3 1.95 4.78 4.18 5.05l1.14 8.75-7.4 7.4-.74-6c1.81-.74 3-2.42 2.82-5.31s-3.23-7.34-4.91-9.56a1.23 1.23 0 00-2 .14c-1.41 2.48-3.83 7.26-3.63 10.09.2 3.29 1.95 4.78 4.17 5.05l1.14 8.74-7.4 7.4-.74-6c1.82-.74 3-2.43 2.82-5.32s-3.23-7.33-4.91-9.55a1.23 1.23 0 00-2 .13C2.27 34.64-.15 39.42.05 42.25c.2 3.29 1.95 4.77 4.17 5L5.37 56 .79 60.58a1.76 1.76 0 002.49 2.48l4.57-4.57 8.75 1.14c.34 2.22 1.82 4 5 4.17 2.82.21 7.67-2.28 10.09-3.63a1.23 1.23 0 00.14-2c-2.29-1.68-6.73-4.71-9.56-4.91s-4.57 1-5.31 2.83l-6-.75 7.4-7.4 8.77 1.24c.34 2.22 1.82 4 5.05 4.17 2.82.2 7.67-2.29 10.09-3.64a1.22 1.22 0 00.13-2c-2.28-1.69-6.73-4.71-9.55-4.92s-4.58 1-5.32 2.83l-6-.74 7.4-7.4 8.75 1.14c.33 2.22 1.81 4 5 4.17 2.83.2 7.67-2.29 10.1-3.63a1.23 1.23 0 00.13-2c-2.29-1.68-6.73-4.71-9.55-4.91s-4.58 1-5.32 2.82l-6-.67 7.41-7.4 8.74 1.14c.34 2.22 1.82 4 5.05 4.17 2.83.2 7.67-2.28 10.09-3.63a1.21 1.21 0 00.21-2z","fill":"#fff"}})])
          )
        }
      }
    